/**
 * Helpers for Windows display scaling (100% / 125% / 150%) and smaller effective viewports.
 * Prefer fluid clamp() and minWidth:0 over fixed px that overflow when DPR/scale changes.
 */

/** Laptop / scaled-desktop: side-by-side hero & dense nav often break below this */
export const COMPACT_DESKTOP_QUERY = "(max-width: 1400px)";

/** Tighter layout for embed charts and bento grids */
export const TIGHT_DESKTOP_QUERY = "(max-width: 1200px)";

/** Collapse marketing top nav earlier than default MUI lg (1200px) */
export const MARKETING_NAV_COLLAPSE_QUERY = "(max-width: 1279px)";

export const fluidClamp = (minPx, maxPx, vw = 2.5) =>
  `clamp(${minPx}px, ${vw}vw, ${maxPx}px)`;

/** Shared container padding that scales down slightly on compact viewports */
export const marketingContainerPx = {
  xs: 2,
  sm: 2.5,
  md: 3,
  lg: 3,
  xl: 4,
};

/** Prevent flex/grid children from forcing horizontal overflow */
export const flexChildMinWidth0 = {
  minWidth: 0,
  maxWidth: "100%",
};

export const scaleSafeOverflow = {
  overflow: "hidden",
  maxWidth: "100%",
  ...flexChildMinWidth0,
};
